import { render, staticRenderFns } from "./curSale-distributionStation-delivery-check-edit.vue?vue&type=template&id=3fb1b700&scoped=true"
import script from "./curSale-distributionStation-delivery-check-edit.vue?vue&type=script&lang=js"
export * from "./curSale-distributionStation-delivery-check-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb1b700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb1b700')) {
      api.createRecord('3fb1b700', component.options)
    } else {
      api.reload('3fb1b700', component.options)
    }
    module.hot.accept("./curSale-distributionStation-delivery-check-edit.vue?vue&type=template&id=3fb1b700&scoped=true", function () {
      api.rerender('3fb1b700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/distributionStation-management/distributionStation-delivery-check/curSale-distributionStation-delivery-check-edit.vue"
export default component.exports